export default "__VITE_ASSET__B6QOO31x__"